module.exports = __webpack_public_path__ + "img/keypal-line.278c6ab2.png";